import React from 'react'
import PropTypes from 'prop-types'
import {VStack} from '@chakra-ui/react'
import CSBreadcrumbs from '../partials/breadcrumbs'
import CSQuickLinks from '../partials/quick-links'
import CSBackLink from '../partials/back-link'

const CustomerServiceLayoutDefault = (props) => {
    const {children, maxWidth = '92rem', px = {base: 4, lg: 8}, pb = 0} = props

    return (
        <>
            <CSBreadcrumbs />
            <VStack alignItems="center" backgroundColor="stokkeGray.bright" gap={0}>
                <VStack gap={8} pt={8} px={px} pb={pb} width="100%" maxW={maxWidth}>
                    {children}
                </VStack>
                <CSBackLink />
                <CSQuickLinks />
            </VStack>
        </>
    )
}

CustomerServiceLayoutDefault.propTypes = {
    children: PropTypes.node,
    maxWidth: PropTypes.string,
    px: PropTypes.object,
    pb: PropTypes.oneOfType([PropTypes.object, PropTypes.number])
}

export default CustomerServiceLayoutDefault
